<template>
  <v-row>
    <v-col class="ep-input-groupping" cols="12" :md="isTwoColumns ? 6 : 12">
      <template v-for="(field, i) of tabbedFields">
        <InputField
          :key="i"
          v-if="!isTwoColumns || !(i % 2)"
          :field="field"
          :value="value(field)"
          :showError="showErrors"
          :error="getError(field)"
          :disabled="disabled"
          @input="onChange"
          @error="onError"
        />
      </template>
    </v-col>

    <v-col v-if="isTwoColumns" class="ep-input-groupping" cols="12" md="6">
      <template v-for="(field, i) of tabbedFields">
        <InputField
          :key="i"
          v-if="i % 2"
          :field="field"
          :value="value(field)"
          :showError="showErrors"
          :error="getError(field)"
          :disabled="disabled"
          @input="onChange"
          @error="onError"
        />
      </template>
    </v-col>
  </v-row>
</template>

<script>
import _ from "lodash";
import InputField from "@/components/fields/Input.vue";
import { mapGetters } from "vuex";

export default {
  name: "Form",

  props: ["fields", "data", "offset", "showErrors", "serverErrors", "disabled"],

  components: { InputField },

  data: () => ({
    valid: false,
    errors: {}
  }),

  methods: {
    onChange(value, field) {
      this.$emit("input", { ...this.data, [field.id]: value }, field);
    },

    onError(error, field) {
      // console.log(field, error);

      this.$set(this.errors, field.id, error);
    },

    getError(field) {
      if (field.type === "group") {
        return this.allErrors;
      }

      return this.allErrors[field.id];
    },

    value(field) {
      // pass the whole object to the group
      // so that can sub inputs change the main object
      if (field.type === "group") {
        return this.data;
      }

      return this.data[field.id];
    }
  },

  watch: {
    errors: {
      deep: true,
      handler() {
        const hasError = Object.values(this.allErrors).some(error => error);

        const valid = !hasError;

        this.valid = valid;
        this.$emit("valid", valid);
      }
    }
  },

  computed: {
    allErrors() {
      return { ...this.errors, ...this.serverErrors };
    },

    isTwoColumns() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    tabbedFields() {
      const newFields = [];
      // used for multiple forms with continuous indexing
      let i = (this.offset || 0) + 1;

      for (const field of this.visibleFields) {
        const newField = { ...field };

        if (newField.type === "group") {
          newField.fields = newField.fields.map(childField => {
            return { ...childField, tabIndex: i++ };
          });
        } else {
          newField.tabIndex = i++;
        }

        newFields.push(newField);
      }

      return newFields;
    },

    visibleFields() {
      return this.fields.filter((field, index) => {
        if (_.isBoolean(field.show)) {
          return field.show;
        }

        if (_.isFunction(field.show)) {
          return field.show(this.data, index);
        }

        return true;
      });
    },
  }
};
</script>

<style lang="scss">
.ep-input-groupping {
  height: 100%;

  input,
  textarea {
    background-color: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
  }

  textarea {
    height: auto !important;
  }
}

.v-input__slot {
  box-shadow: none !important;
}
</style>
